import React from "react";
import classes from "./ToggleButton.module.scss";
import smallToggleBtnclasses from "./SmallToggleButton.module.scss";

const ToggleButton = ({
  enable = false,
  handleClick,
  leftText = "ON",
  rightText = "OFF",
  isRed = false,
  type = "large",
  disabled = false,
  isActive = false,
}) => {
  return type === "large" ? (
    <div className={classes.list__item}>
      <label className={classes.switch}>
        <input
          type="checkbox"
          checked={!disabled && enable}
          onChange={handleClick}
          value={enable}
          disabled={disabled}
        />
        <span
          className={
            enable && !disabled
              ? classes.slider + " " + classes.round
              : isRed
              ? classes.sliderRed + " " + classes.roundRed
              : isActive
              ? classes.sliderGrey + " " + classes.roundGrey + " " + classes.sliderActive
              : classes.sliderGrey + " " + classes.roundGrey
          }
          style={{ cursor: disabled ? "not-allowed" : "pointer" }}
        >
          <span className={classes.on}>{leftText}</span>
          <span className={classes.off}>{rightText}</span>
        </span>
      </label>
    </div>
  ) : (
    <div className={smallToggleBtnclasses.small_toggle_button}>
      <div className={smallToggleBtnclasses.list__item}>
        <label className={smallToggleBtnclasses.switch}>
          <input
            type="checkbox"
            checked={!disabled && enable}
            onChange={handleClick}
            value={enable}
            disabled={disabled}
          />
          <span
            className={
              enable && !disabled
                ? smallToggleBtnclasses.slider +
                  " " +
                  smallToggleBtnclasses.round
                : isRed
                ? smallToggleBtnclasses.sliderRed +
                  " " +
                  smallToggleBtnclasses.roundRed
                : smallToggleBtnclasses.sliderGrey +
                  " " +
                  smallToggleBtnclasses.roundGrey
            }
            style={{ cursor: disabled ? "not-allowed" : "pointer" }}
          >
            {/* <span className={classes.on}>{leftText}</span>
            <span className={classes.off}>{rightText}</span> */}
          </span>
        </label>
      </div>
    </div>
  );
};

export default ToggleButton;
